module.exports = __webpack_public_path__ + "static/media/icon-key-findings.76efb511.svg";